import { Controller } from "@hotwired/stimulus"

// Toggles a document's "source" PDF view on and off, in place of the regular
// details view, entirely on the front-end.
//
// - The source PDF iframe is loaded lazily: its `src` is only set the first
//   time the source view is shown, avoiding an unnecessary fetch.
// - The active view is kept in sync with the `view_mode` query param so the
//   source view can be deep-linked to from elsewhere.
export default class extends Controller {
  static targets = ["details", "source", "iframe", "button", "icon"]
  static values = {
    param: { type: String, default: "view_mode" }
  }

  connect() {
    // Reflect the initial state (e.g. when deep-linked via ?view_mode=source).
    this.showingSource = !this.sourceTarget.classList.contains("d-none")
    if (this.showingSource) this.loadIframe()
    this.updateButton()
  }

  toggle() {
    this.showingSource = !this.showingSource

    this.detailsTarget.classList.toggle("d-none", this.showingSource)
    this.sourceTarget.classList.toggle("d-none", !this.showingSource)

    if (this.showingSource) this.loadIframe()

    this.updateButton()
    this.updateUrl()
  }

  loadIframe() {
    if (!this.hasIframeTarget) return
    if (this.iframeTarget.getAttribute("src")) return

    this.iframeTarget.setAttribute("src", this.iframeTarget.dataset.src)
  }

  updateButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.toggle("border-primary", this.showingSource)
      this.buttonTarget.classList.toggle("text-primary", this.showingSource)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-toggle-on", this.showingSource)
      this.iconTarget.classList.toggle("fa-toggle-off", !this.showingSource)
    }
  }

  updateUrl() {
    const url = new URL(window.location.href)

    if (this.showingSource) {
      url.searchParams.set(this.paramValue, "source")
    } else {
      url.searchParams.delete(this.paramValue)
    }

    window.history.replaceState({}, "", url)
  }
}
